import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { gsap, Power4 } from 'gsap';

@Component({
  selector: 'os-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'web';

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    const percentElement = this.elementRef.nativeElement.querySelector(
      '.loading-percent-count'
    ) as HTMLParagraphElement;

    this.animateFrom(percentElement);
  }

  animateFrom(elem) {
    const introLoadingElement: HTMLDivElement =
      this.elementRef.nativeElement.querySelector('.intro-loading-box');

    const percentBoxElement: HTMLDivElement =
      this.elementRef.nativeElement.querySelector('.loading-percent-box');
    const centerOElement: HTMLDivElement =
      this.elementRef.nativeElement.querySelector('.center-loading-text-box');
    const centerLogoBoxElement: HTMLDivElement =
      this.elementRef.nativeElement.querySelector('.center-logo-box');

    const firstSymbolElement: HTMLDivElement =
      this.elementRef.nativeElement.querySelector('.first-show-symbol');

    const secondSymbolElement: HTMLDivElement =
      this.elementRef.nativeElement.querySelector('.second-show-symbol');

    let delay = 500;

    if (elem.dataset.delay) {
      delay = parseInt(elem.dataset.delay, 10) / 1000;
    }

    const target = { val: 0 };
    let isTrigger = false;

    gsap.to(target, {
      duration: 2,
      val: 100,
      ease: Power4.easeInOut,
      onUpdate: () => {
        elem.innerHTML = Math.ceil(target.val);
        if (Math.ceil(target.val) > 97 && Math.ceil(target.val) < 100) {
          percentBoxElement.classList.add('loading__complete');
        } else if (Math.ceil(target.val) === 100 && !isTrigger) {
          isTrigger = true;
          percentBoxElement.classList.add('opacity__hide');

          setTimeout(() => {
            introLoadingElement.classList.add('animation__show__first');
          }, 250);

          setTimeout(() => {
            introLoadingElement.classList.add('status__complete');
          }, 3000);
        }
      },
    });
  }
}
